const fixedEncodeURIComponent = str =>
    encodeURIComponent(str).replace(/[!'()*]/g, c => '%' + c.charCodeAt(0).toString(16).toUpperCase());

export const encodeURI = (uri, encodeSlash) =>
    uri
        .split('/')
        .map(fixedEncodeURIComponent)
        .join(encodeSlash ? '%2F' : '/');

export const convertGsutilPathToBrowserGcsUrl = gcsFileLocation => {
    let fileNameQueryString, locationWithoutFileName;
    const prefix = 'https://console.cloud.google.com/storage/browser/';
    const filenameIndex = gcsFileLocation && gcsFileLocation.lastIndexOf('/');
    if(gcsFileLocation && gcsFileLocation.includes('.')) {
        fileNameQueryString = `?prefix=${gcsFileLocation.substr(filenameIndex + 1, gcsFileLocation.length)}`
        locationWithoutFileName = gcsFileLocation.substr(0, filenameIndex)
    } else {
        fileNameQueryString = ""
        locationWithoutFileName = gcsFileLocation
    }

    return gcsFileLocation &&
        (prefix
            + encodeURI(locationWithoutFileName.replace('gs://', ''), false)
            + fileNameQueryString
        );
};